import React from "react";
import { LOOKS } from "../lib/site";
import Reveal from "./Reveal";

export default function Looks() {
  return (
    <section id="looks" className="bg-white py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14">
        {/* Header */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-20">
          <Reveal className="md:col-span-5">
            <h2 className="serif text-[42px] sm:text-[56px] md:text-[64px] leading-[1.05] text-[#111] font-light">
              The Magic Six.
            </h2>
          </Reveal>
          <Reveal className="md:col-span-6 md:col-start-7" delay={120}>
            <p className="sans text-[16px] leading-[1.8] text-[#111]/90 max-w-[540px]">
              Six distinct ways to tie, twist and wear the same piece. From a clean
              boobtube on the bridge to a Roman drape at sunset, each silhouette
              reframes the same fabric into something altogether new.
            </p>
          </Reveal>
        </div>

        {/* 3x2 grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5 lg:gap-6">
          {LOOKS.map((look, idx) => (
            <Reveal key={look.id} delay={(idx % 3) * 90} className="lookcard aspect-[3/4]" data-testid={`look-card-${look.id}`}>
              <img
                src={look.image}
                alt={`${look.name} silhouette`}
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <span className="number">N° {look.number}</span>
              <div className="label">
                <div className="serif italic text-[22px] leading-tight">{look.name}</div>
                <div className="sans text-[12px] tracking-wider-elegant mt-1">
                  {look.caption}
                </div>
              </div>
              {/* permanent caption underneath gradient for legibility on lighter shots */}
              <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/55 to-transparent" />
              <div className="absolute left-5 bottom-5 text-white">
                <div className="text-[12px] sans tracking-luxe opacity-95">N° {look.number}</div>
                <div className="serif italic text-[22px] leading-tight">{look.name}</div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Caption */}
        <Reveal className="mt-14 md:mt-20 text-center">
          <p className="serif italic text-[22px] sm:text-[26px] text-[#111]/95 max-w-[720px] mx-auto leading-[1.5]">
            Six distinct looks. One buttery soft fabric. Infinite ease.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
